export const AUTH = "AUTH";
export const REMOVE_ERRORS = "REMOVE_ERRORS";
export const LOGOUT = "LOGOUT";

export const SUBMIT_ORDER = "SUBMIT_ORDER";
export const FETCH_ALL = "FETCH_ALL";

export const ADD_CART_ITEM = "ADD_CART_ITEM";
export const REMOVE_CART_ITEM = "DELETE_CART_ITEM";
export const PATCH_CART_ITEM = "PATCH_CART_ITEM";
export const RESET_CART_ITEMS = "RESET_CART_ITEMS";